import React from "react";
import Slider from "react-slick"; 
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import Hour from '../assets/hora.png';
import ProductoExtra from "../assets/logo-lani.png";
import BasicButtons from "./button";
import { Link } from "react-scroll";

const Products = () => {
    const settings = {
      dots: true, 
      infinite: true, 
      speed: 800, 
      slidesToShow: 1, 
      slidesToScroll: 1, 
      arrows: true, 
    };
  
    return (
      <section id="productos"  className="products-section">
        <div className="products-header">
          <div className="products-title">
            <h2><strong>NUESTROS <br /> PRODUCTOS </strong></h2>
          </div>
          <div className="products-container">
            <p>Desarrollamos herramientas <br />tecnológicas que resuelven <br />problemas reales.</p> 
          </div>   
        </div>
  
        {/* Slider con imágenes de productos */}
        <Slider {...settings} className="products-slider">
  <div className="product-card">
    <a href="https://hora.app/" target="_blank" rel="noopener noreferrer">
      <img src={Hour} alt="Producto 1" />
    </a>
  </div>
  <div className="product-card extra-product">
    <a href="http://lanicrm.com/" target="_blank" rel="noopener noreferrer">
      <img src={ProductoExtra} alt="Producto 2" />
    </a>
  </div>
</Slider>

        <p className="cta-text">¿Tienes una idea? La hacemos realidad.</p>
        <Link to="contacto" smooth={true} duration={500}>
  <BasicButtons text="Hablemos" />
</Link>
      </section>
    );
  };

export default Products;

